<template>
  <of-dialog title="物品捐赠详情" @onCancel="cancel" width="1000px">
    <div slot="content">
      <el-form ref="form" label-width="150px">
        <el-divider content-position="left">基础信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="捐赠者：" prop="Name">
              <div class="box-value">{{ dataForm.Name }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="捐赠者类型：" prop="Donation">
              <div class="box-value">
                {{ dataForm.Donation === 1 ? "个人" : "企业" }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="捐赠者电话：" prop="Phone">
              <div class="box-value">{{ dataForm.Phone }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="捐赠项目：" prop="ProjectId">
              <div class="box-value">{{ dataForm.ProjectName }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="配送方式：" prop="MailingType">
              <div class="box-value">
                {{ dataForm.MailingType === 1 ? "快递邮寄" : "送货上门" }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否开票：" prop="IsInvoice">
              <div class="box-value">
                {{ dataForm.IsInvoice ? "需要" : "不需要" }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="捐赠留言：" prop="Remark">
              <div class="box-value">{{ dataForm.Remark || '-' }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">物品信息</el-divider>
        <el-table :data="materialsform" border style="width: 100%">
          <el-table-column
            prop="MaterialName"
            label="物品名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="MaterialType"
            label="品牌"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Number"
            label="数量"
            align="center"
            :show-overflow-tooltip="true"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="Unit"
            label="规格"
            align="center"
            :show-overflow-tooltip="true"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="UnitPrice"
            label="单价"
            align="center"
            :show-overflow-tooltip="true"
            width="120"
          ></el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.Picture"
                @click="read(scope.row)"
                type="text"
                size="mini"
                >查看图片
              </el-button>
              <el-button
                v-if="scope.row.File"
                @click="download(scope.row)"
                type="text"
                size="mini"
                >下载附件
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-dialog title="图片预览" width="450px" :visible.sync="dialogVisible" :append-to-body="true">
        <img
          style="width: 400px; height: 400px; "
          :src="dialogImageUrl"
          alt
        />
      </el-dialog>
      <image-viewer :imageViewerUrl="url" v-if="isPreview" @closeImageViewer="(isPreview = false, url = '')" />
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import ImageViewer from '@/components/controls/of_imageViewer'

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      width: "60%",
      materialsform: [], //物资详情
      totalamount: 0, //总金额
      dialogImageUrl: "",
      dialogVisible: false,
      url: '',
      isPreview: false
    };
  },
  mounted() {
    this.getList();
  },
  components: {
    OfDialog,
    ImageViewer
  },
  methods: {
    //获取物资详情
    getList() {
      let self = this;
      let params = { Id: this.dataForm.Id };
      api.QueryMaterialsDetailById(params).then(function(res) {
        self.materialsform = res.data.Data;
        self.materialsform.forEach(function(item) {
          self.totalamount += item.Amount;
        });
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //查看图片
    read(rowData) {
      let that = this;
      // that.url = "/api/File/Download?Id=" + rowData.Picture;
      // that.isPreview = true;

      that.dialogImageUrl = "/api/File/Download?Id=" + rowData.Picture;
      that.dialogVisible = true;
    },
    //下载附件
    download(rowData) {
      let file = JSON.parse(rowData.File);
      saveAs("/api/File/Download?Id=" + file[0].url, file[0].name);
    },
  },
};
</script>

<style scoped>
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--default {
  display: none;
}
.cardbutton {
  float: right;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}

.box-value {
  border-bottom: 1px dashed #c9c6c6;
}
</style>
